import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Level_detail() {
  const { userId } = useSelector((state) => state.Auth);
  const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "224411";
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(user);
  //   const [current, setCurrent] = useState('')
  const [currentPage, setcurrentPage] = useState(1);
  const [select, setSelect] = useState("2");
  const [position, setPosition] = useState("0");
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);
  const [positionfilter, setpositionfilter] = useState("0");
  const [StatusFilter, setStatusFilter] = useState("2");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  let arrayLeft = [];
  //   let value = 2
  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/LevelDetailsAdmin",
        {
          loginid: userId,
          uid: search,
          fdate: formdate,
          tdate: todate,
          leveltype: position,
          status: select,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("Level_detail", responceRight?.data?.data);
      responceRight = responceRight?.data?.data?.[0];
      setleftreferralApi([]);

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item.row,
          uid: item.uid,
          sid: item.sid,
          idType: item.idType,
          f_name: item.f_name,
          email: item.email,
          mobile: item.f_mobile,
          wallet: item.wallet,
          packagename: item.packagename,
          pakage: item.packageamount,
          activationDate: item.activationDate,
          status:
            item.status == "Active" ? (
              <span style={{ color: "green" }}>{item.status}</span>
            ) : (
              <span style={{ color: "red" }}>{item.status}</span>
            ),
          dd: item.registrationDate,
          mobile: item.mobile,
          currentPackage: item.currentPackage,
          totalPackage: item.totalPackage,
          Leveltype: item.leveltype,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, [positionfilter, StatusFilter]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Mobile.", accessor: "mobile" },
      { Header: "Email", accessor: "email" },
      { Header: "sid", accessor: "sid" },
      //{ Header: "wallet", accessor: "wallet" },
      //{ Header: "Package Name", accessor: "packagename" },
      { Header: "Level", accessor: "Leveltype" },
      //{ Header: "Package Amount", accessor: "pakage" },
      { Header: "Registration Date", accessor: "dd" },
      { Header: "Status", accessor: "status" },

      { Header: "Activation Date", accessor: "activationDate" },
      { Header: "Current Package", accessor: "currentPackage" },
      { Header: "Total Package", accessor: "totalPackage" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="panel panel-primary">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Level Details</h4>
                </div>
                <div class="panel-body">
                  <form ng-submit="SearchUserid();">
                    <div class="form-inline" role="form">
                      <div class="col-md-12">
                        <div class="col-md-2">
                          <input
                            type="text"
                            id="SelectUid"
                            onChange={(e) => setSearch(e.target.value)}
                            name="SelectUid"
                            class="form-control in-ip-1"
                            placeholder="Enter User Id"
                          />
                        </div>
                        <div class="col-md-2">
                          <select
                            class="form-control"
                            id="SelectLevel"
                            onChange={(e) => setPosition(e.target.value)}
                            name="SelectLevel"
                          >
                            <option value="0">All Level</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24">24</option>
                            <option value="25">25</option>
                            <option value="26">26</option>
                            <option value="27">27</option>
                            <option value="28">28</option>
                            <option value="29">29</option>
                            <option value="30">30</option>
                          </select>
                        </div>
                        <div class="col-md-2">
                          <select
                            class="form-control"
                            onChange={(e) => setSelect(e.target.value)}
                            id="SelectStatus"
                            name="SelectStatus"
                          >
                            <option value="">Select Status</option>
                            <option value="2">All</option>
                            <option value="1">Active</option>
                            <option value="0">In-Active</option>
                          </select>
                        </div>
                        {/* <div class="col-md-2">
                            <input
                              class="form-control in-ip-1"
                              onChange={(e) => setTodate(e.target.value)}
                              id="todate"
                              name="todate"
                              type="date"
                            />
                          </div>
                          <div class="col-md-2">
                            <input
                              class="form-control in-ip-1"
                              onChange={(e) =>
                                setFromdate(new Date(e.target.value))
                              }
                              id="fdate"
                              name="fdate"
                              type="date"
                            />
                          </div>  */}
                        <div class="col-md-2">
                          <input
                            type="button"
                            id="btnsearch"
                            onClick={() => referral_API()}
                            class="btn btn-lg btn-primary"
                            value="Search"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="panel panel-default">
                <div class="panel-body" style={{ overflow: "scroll" }}>
                  <Table data={currentPostleft} columns={my_team.cols} />

                  <Table_Buttons
                    indexOfFirstPage={indexOfFirstPage2}
                    indexOfLastPost={indexOfLastPost2}
                    setcurrentPage={setcurrentPage2}
                    currentPage={currentPage2}
                    totalData={leftreferralApi.length}
                    listPerpage={listPerpage2}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Level_detail;
